import React, { useEffect, useState, useRef } from "react";
import Spinner from "../../components/Tools/spinner";
import DashboardBox from "../../components/DashboardBox/DashboardBox";
import { get_dashboard_data } from "../../helper/Api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import MainFilter from "../../components/Tools/MainFilter";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import SubHeader from "../../components/Subheader/Subheader";
import { useNavigate } from "react-router-dom";
import { DEFAULT_EXPENSE_DATE_BASIS } from "../../RTK/Slices/AppConfigSlice";

const Dashboard = () => {
const { authData, financialYears } = useSelector((state) => state.authData);
const expenseDateBasis = useSelector(
  (state) => state.appConfig?.expenseDateBasis || DEFAULT_EXPENSE_DATE_BASIS
);
const [loading, setLoading] = useState(false);
const navigate = useNavigate();
const [open, setOpen] = useState(false);
const fy_list = financialYears.payload.fy_list;
const reloadList = useRef(false);
const [data, setData] = useState({
  curr_surrender: {
    approved_surrender: 0,
    pending_surrender: 0,
    surrender_i_got: 0,
  },
  total_provisional_budget: {
    provisional_budget: 0,
    released_budget: 0,
  },
  currenyFyUtilization: 0,
  prevFyUtilization: 0,
  prevYearBalance: 0,
  payable_expanses: 0,
  sanctioned_amount: 0,
  accumulated: [
    {
      deduction: 0,
    },
  ],
  reimbursement_details: [
    {
      under_approval: 0,
    },
    {
      payment_approval: 0,
    },
  ],
  salary_details: [
    {
      under_approval: 0,
    },
    {
      payment_approval: 0,
    },
  ],
  stats: [
    {
      budget_allocation_pending_count: 0,
      invoice_pending_count: 0,
      invoice_payment_pending_count: 0,
      dbt_pending_approval_count: 0,
      dbt_pending_payment_approval: 0,
    },
  ],
});
const fyId = localStorage.getItem('globalDateId');
const fyIdRef = useRef(localStorage.getItem('globalDateId'));
const [activeFyId, setActiveFyId] = useState(() => localStorage.getItem('globalDateId'));
const [filterPayload, setFilterPayload] = useState({
    searchStr: "",
    fromDate: "",
    toDate: "",
    dateColumn: "",
    department_id: "",
    tier: ""
});

useEffect(() => {
  loadFullDashboard(fyId);
}, [fyId, authData])

const loadFullDashboard = async (fy_id, payload = filterPayload) => {
  await fetch_dashboard_data(fy_id, payload.department_id || authData.user.department_id);
};

const handleFinancialYearChange = async (e) => {
  const val = e.target.value;
  localStorage.setItem("globalDateId", val);
  setActiveFyId(val);
  await loadFullDashboard(val);
};

const fetch_dashboard_data = async (
  fyId = null,
  departmentId = null,
  tier = null
) => {
  try {
    setLoading(true);
    const { data } = await get_dashboard_data({
      fy_id: fyId,
      department_id: departmentId,
      department_level: tier,
      expense_date_basis: expenseDateBasis,
    });
    if (data.status) {
      setData(data);
      setLoading(false);
    } else {
      setLoading(false);
      toast.error("Something Went Wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  } catch (error) {
    setLoading(false);
    toast.error("Something Went Wrong", {
      position: toast.POSITION.TOP_CENTER,
    });
  }
};

const handleFilterClick = async () => {
  setOpen(false);
  await loadFullDashboard(fyId);
};

const [divider, setDivider] = useState(1);

const handleOpen = () => setOpen(true);
const handleClose = () => setOpen(false);
const handleInput = async (e) => {
    const {name, value} = e.target;
    setFilterPayload((prev) => ({
        ...prev, [name]: value
    }));
}

const handleFilterRemove = async (name) => {
    const newPayload = {
    ...filterPayload,
    [name]: "",
  };
  setFilterPayload(newPayload);
  loadFullDashboard(fyId, newPayload);
}

const [divisionNumber, setDivisionNumber] = useState(() => {
  const stored = localStorage.getItem('globalAmountDivisor');
  return stored ? Number(stored) : 1;
});
useEffect(()=>{
  setDivider(divisionNumber);
},[divisionNumber])

const handlePageTrigger = () => {
    const nextFyId = localStorage.getItem('globalDateId');
    fyIdRef.current = nextFyId;
    setActiveFyId(nextFyId);
    loadFullDashboard(nextFyId);
}


  return (
    <>
    {loading && <div > <Spinner/> </div>}
    <SubHeader fy_list={fy_list} setDivisionNumber={setDivisionNumber} handlePageTrigger={handlePageTrigger}/>
    <div className="row" style={{ padding: "10px 16px" }}>
      <div className="col-md-6">
          <h4 style={{ color: "#28326f", margin:0}}>Dashboard</h4>
          <CustomBreadcrumbs linksArray={[]} title="Dashboard"/>
      </div>
      <div className="col-md-6">
        <div className="m-0 p-0 d-flex gap-2" style={{ width: "auto", float: "right" }}>
          <button type="button" className="navigation_button" ><span className="fs-14px" onClick={() => navigate("/consolidate-ppa")}>Consolidate PPA Report</span></button>
        </div>
      </div>
    </div>
    
    <div className="overflow-x-hidden" style={{ backgroundColor: "#F1F1F1" }}>

      <DashboardBox
        openFilterModal={setOpen}
        handleYearDropdown={handleFinancialYearChange}
        data={data}
        listReload={reloadList.current}
        dividerNumber={divider}
        filterPayload={filterPayload}
        fy_list={fy_list}
        fyId={activeFyId}
        handleFilterRemove={handleFilterRemove}
      />

      {/* ========================================filter modal==================================================== */}

      <MainFilter 
        open={open} 
        handleClose={handleClose} 
        handleInput={handleInput} 
        handleOpen={handleOpen}
        filterPayload={filterPayload}
        handleFilterClick={handleFilterClick}
      />
    </div></>
  );
};


export default Dashboard;

